import { Component } from 'opus-angular-seed-core';

/**
 * Renders the matched log rows.
 *
 * Each row keeps its original Linux terminal colors (converted from ANSI escape
 * sequences) and turns known identifiers into clickable links. Clicking a link
 * emits the token so the parent can re-filter the log by it.
 */
@Component({
    bindings: {
        rows: '<',
        onToken: '&'
    },
    template: `
        <div class="application-log-output">
            <div class="application-log-line" ng-repeat="row in vm.rows track by $index" ng-bind-html="vm.renderRow(row)"></div>
        </div>
    `
})
export default class {
    constructor ($element, $scope, $sce, ApplicationLogService) {
        this.$element = $element;
        this.$scope = $scope;
        this.$sce = $sce;
        this.ApplicationLogService = ApplicationLogService;
    }

    $onInit () {
        // A single delegated click handler keeps this generic: any new token type
        // added to ApplicationLogService becomes clickable without extra wiring.
        this.clickHandler = (event) => {
            const target = event.target;
            if (!target || !target.classList.contains('application-log-token')) {
                return;
            }
            event.preventDefault();
            const type = target.getAttribute('data-token-type');
            const value = target.getAttribute('data-token-value');
            this.$scope.$apply(() => {
                this.onToken({ type, value });
            });
        };
        this.$element[0].addEventListener('click', this.clickHandler);
    }

    $onDestroy () {
        if (this.clickHandler) {
            this.$element[0].removeEventListener('click', this.clickHandler);
        }
    }

    renderRow (row) {
        return this.$sce.trustAsHtml(this.ApplicationLogService.toHtml(row.content));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/applicationlog/output/index.js